var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPerformance = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 80 80"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("path", {
  strokeWidth: 2,
  d: "M74.5 67.5H60.25a3 3 0 0 1-2.611-1.524L41.755 37.874c-1.179-2.085-4.204-2.017-5.288.119L22.334 65.857a3 3 0 0 1-2.675 1.643H6.5"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 2,
  d: "M71.059 67 58.452 45.664c-1.055-1.786-3.561-1.987-4.888-.393L49.21 50.5M9 67l9.324-16.215c1.049-1.825 3.602-2.03 4.929-.397L27 55"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 64h11M14 61h11M15 58h11M17 55h10M17 52h8"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 2,
  d: "M39 36V23m0 0v-8.803a3 3 0 0 1 3.971-2.838l16.963 5.803C63.14 18.259 62.352 23 58.963 23z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26 68v-9M32 68V47M38 68V37M44 68V41M50 68V53M29 68V53M35 68V41M41 68V37M47 68V47M53 68V58M57 64h12M55 61h12M54 58h12M52 55h12M50 52h12M51 49h9"
}))));
export default SvgPerformance;